import React from "react";

import screenfull from "screenfull";
import { Link, useMatch, useResolvedPath } from "react-router";
import { APP_TYPE } from "../constants";

import PermalinkMenuItem from "./PermalinkMenuItem";
import Tooltip from "./base/Tooltip";
import {
  ArrowLeftToLineIcon,
  Earth,
  GlobeIcon,
  Layers,
  MapPin,
  Maximize2,
  Settings,
} from "lucide-react";
import { cn } from "src/lib/utils";


type MenuLinkProps = {
  to: string;
  children: React.ReactNode;
  tooltip?: string;
  className?: string;
};
const MenuLink = ({
  to,
  children,
  tooltip = undefined,
  ...props
}: MenuLinkProps) => {
  const resolved = useResolvedPath(to);
  const match = useMatch(resolved.pathname + "/*");
  const className = cn('cursor-pointer p-2 my-1', {'bg-qmprimary': match});
  return (
    <Tooltip content={tooltip}>
      <li {...props} className="flex items-center justify-center">
        {match ? (
          <Link className={className} to="./">
            {children}
          </Link>
        ) : (
          <Link className={className} to={to}>
            {children}
          </Link>
        )}
      </li>
    </Tooltip>
  );
};

function Menu() {
  return (
    <div className="absolute top-0 left-0 h-full w-9 bg-qmdark-900">
      <ul className="flex flex-col h-full m-0 p-0 SideMenu-list">
        <MenuLink to="projections" tooltip="Switch Projections">
          <GlobeIcon size={18} strokeWidth={1.5} />
        </MenuLink>
        <MenuLink to="layers" tooltip="Layers">
          <Layers size={18} />
        </MenuLink>
        <MenuLink to="query" tooltip="Draw/Search Tool">
          <MapPin size={18} />
        </MenuLink>
        <MenuLink to="settings" tooltip="Settings">
          <Settings size={18} />
        </MenuLink>
        {screenfull.isEnabled ? (
          <Tooltip content="Toggle fullscreen">
            <li
              onClick={() => screenfull.toggle()}
              className={`p-2 ${screenfull.isFullscreen ? "bg-qmprimary" : ""}`}
            >
              <a href="#">
                <Maximize2 size={18} />
              </a>
            </li>
          </Tooltip>
        ) : (
          ""
        )}
        <Tooltip content="Share">
          <li className="flex mt-auto items-center justify-center">
            <PermalinkMenuItem />
          </li>
        </Tooltip>
        <MenuLink to="help" tooltip="Help" className="help">
          <div className="w-[18px] h-[18px] inline-flex items-center justify-center text-[16px]">
            ?
          </div>
        </MenuLink>
        {APP_TYPE !== "simple" ? (
          <MenuLink to="/" tooltip="Back to Main Menu">
            <ArrowLeftToLineIcon size={18} />
          </MenuLink>
        ) : null}
      </ul>
    </div>
  );
}
export default Menu;
